/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var childProcess = require('child_process');

function execFile(cmd, args) {
  return new Promise(function (resolve, reject) {
    childProcess.execFile(cmd, args, function (err) {
      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
}
/**
 * An abstraction over the source control system to make it injectable.
 */


var SourceControlMercurial = {
  addRemove: function () {
    var _addRemove = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(added, removed) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(added.length > 0)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return execFile('hg', ['add'].concat((0, _toConsumableArray2["default"])(added)));

            case 3:
              if (!(removed.length > 0)) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return execFile('hg', ['forget'].concat((0, _toConsumableArray2["default"])(removed)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function addRemove(_x, _x2) {
      return _addRemove.apply(this, arguments);
    }

    return addRemove;
  }()
};
module.exports = {
  SourceControlMercurial: SourceControlMercurial
};